import { WebPlugin } from '@capacitor/core';
export class DozeOptimizeWeb extends WebPlugin {
    async isIgnoringBatteryOptimizations() {
        throw new Error('Method not implemented.');
    }
    async requestOptimizationsMenu() {
        throw new Error('Method not implemented.');
    }
    async isIgnoringDataSaver() {
        throw new Error('Method not implemented.');
    }
    async requestDataSaverMenu() {
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=web.js.map